import { NavItem } from './nav-item';

export class ProductsNavItem extends NavItem {}
